// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22LLv","requiredAsterisk":"Info_requiredAsterisk__1s3-F"};